import * as React from 'react';
import { Menu, Icon, Row, Col } from 'antd';
import { NavLink } from 'react-router-dom';
import { SFooter } from '../Footer.Styled';
import DarkLogoImg from '../../../assets/images/VMBSIPOIMG.png';

import TcDoc from '../../../assets/Files/VMWM_IPO_System_Terms_and_Conditions.pdf';
import PrivacyDoc from '../../../assets/Files/VMWM_IPO_System_Data_Protection_Privacy_Policy.pdf';
import MenuAvatar from '../MenuAvatar';
import styled from 'styled-components';
import AuthContext from '../../../Context/AuthContext';

export interface Props {
    children?: React.ReactNode;
}

export interface State { }

export default class FooterLayout extends React.Component<Props, State> {
    static contextType = AuthContext;
    context!: React.ContextType<typeof AuthContext>;

    constructor(props: Props) {
        super(props);

        this.state = {};
    }

    render() {
        return (
            <SFooter>
                <Row type="flex">
                    <Col xs={{ span: 24, order: 3 }} sm={{ span: 8, order: 1 }} style={{textAlign:'center'}} >
                        <img src={DarkLogoImg} style={{ maxHeight: '130px', maxWidth: '100%' }} />

                    </Col>
                    <Col xs={{ span: 12, order: 1 }} sm={{ span: 8, order: 2 }}  style={{ color: 'white !important' }}>
                        <h4 style={{ color: 'white' }}>About</h4>
                        <div><a href="https://vmwealth.myvmgroup.com" target="_blank" style={{ color: 'white' }}>VM Wealth</a></div>
                        <div><a href="https://myvmgroup.com/personal-investment-overview/" target="_blank" style={{ color: 'white' }}>Why VM Wealth</a></div>
                        <div><a href="https://vmwealth.myvmgroup.com/board-of-directors/" target="_blank" style={{ color: 'white' }}>Board of Directors</a></div>
                        <div><a href="https://vmwealth.myvmgroup.com/our-leadership-team/" target="_blank" style={{ color: 'white' }}>Leadership Team</a></div>
                    </Col>
                    <Col xs={{ span: 12, order: 2 }} sm={{ span: 8, order: 3 }}  style={{ color: 'white !important' }}>
                        <h4 style={{ color: 'white' }}>Helpful Links</h4>
                        <div><NavLink to={'/faq'} style={{ color: 'white' }}>Frequently Asked Questions</NavLink></div>
                        <div><a href="https://vmwealth.myvmgroup.com/feedback/" target="_blank" style={{ color: 'white' }}>Contact</a></div>
                        <div><a href={TcDoc} target="_blank" style={{ color: 'white' }}>Terms of Use</a></div>
                        <div><a href={PrivacyDoc} target="_blank" style={{ color: 'white' }}>Privacy Policy</a></div>

                    </Col>

                </Row>
                <Row type="flex" align="bottom">
                    <Col xs={{ span: 24 }} sm={{ span: 12, offset: 8 }}  >&copy; Copyright 2021 VM Wealth </Col>
                    {/*<Col span={8} offset={8}>*/}
                    {/*    <div className='social-media'>*/}
                    {/*        <Icon type="facebook" theme="filled" />*/}
                    {/*        <Icon type="instagram" theme="filled" />*/}
                    {/*        <Icon type="twitter-circle" theme="filled" />*/}
                    {/*    </div>*/}
                    {/*</Col>*/}
                </Row>
            </SFooter>
        );
    }
}






